















import { namespace } from 'vuex-class';
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import AuthContainer from '@/views/pages/components/AuthContainer.ts.vue';

const Auth = namespace('auth');

@Component({
  components: {
    AuthContainer
  }
})
export default class VerifyEmail extends Vue {
  
  private message: string = '';
  @Auth.State('me')
  private me: any;
  
  get emailAddress (): string {
    let email = '';
    try {
      email = this.me.user.email
    } catch (e) {
      email = ''
    } finally {
      return email
    }
  }
  
  @Auth.Action
  private verifyEmail!: () => Promise<ServerSuccessResponse>
  
  public sendVerfication (): void {
    const { verifyEmail } = this;
    verifyEmail().then(result => {
      console.log(result)
    })
  }
}
